import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X, Zap, LayoutDashboard } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { resolveCtaTarget } from "@/lib/ctaTarget";

export const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const { user } = useAuth();
    const ctaTarget = resolveCtaTarget(user);
    const isLogged = !!user;

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 80);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="navbar"
            className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
            style={{
                backdropFilter: scrolled ? "blur(24px)" : "blur(0px)",
                WebkitBackdropFilter: scrolled ? "blur(24px)" : "blur(0px)",
                backgroundColor: scrolled ? "rgba(10,10,15,0.8)" : "transparent",
                borderBottom: scrolled ? "1px solid var(--border)" : "1px solid transparent",
            }}
        >
            <nav className="container-mx flex items-center justify-between h-[72px]">
                <a href="#top" className="flex items-center gap-2 font-display font-bold text-xl" data-testid="logo">
                    <Zap size={20} className="text-primary-c" fill="#6D5EF8" />
                    <span>AutoAds</span>
                </a>

                <div className="hidden md:flex items-center gap-2">
                    {isLogged ? (
                        <button
                            onClick={() => navigate(ctaTarget)}
                            className="btn-primary text-sm pulse-glow"
                            data-testid="nav-cabinet-btn"
                        >
                            <LayoutDashboard size={14} /> Кабінет
                        </button>
                    ) : (
                        <>
                            <button onClick={() => navigate("/login")} className="btn-ghost text-sm" data-testid="nav-login-btn">
                                Увійти
                            </button>
                            <button onClick={() => navigate(ctaTarget)} className="btn-primary text-sm pulse-glow" data-testid="nav-cta-btn">
                                Спробувати безкоштовно — 7 днів
                            </button>
                        </>
                    )}
                </div>

                <button
                    className="md:hidden text-text-primary p-2"
                    onClick={() => setOpen((v) => !v)}
                    data-testid="nav-hamburger-btn"
                    aria-label="menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </nav>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="md:hidden glass border-t border-border px-6 py-6 flex flex-col gap-3"
                >
                    {isLogged ? (
                        <button
                            onClick={() => navigate(ctaTarget)}
                            className="btn-primary w-full justify-center"
                            data-testid="mobile-cabinet-btn"
                        >
                            <LayoutDashboard size={14} /> Кабінет
                        </button>
                    ) : (
                        <>
                            <button onClick={() => navigate("/login")} className="btn-ghost w-full justify-center" data-testid="mobile-login-btn">
                                Увійти
                            </button>
                            <button onClick={() => navigate(ctaTarget)} className="btn-primary w-full justify-center" data-testid="mobile-cta-btn">
                                Спробувати безкоштовно — 7 днів
                            </button>
                        </>
                    )}
                </div>
            )}
        </header>
    );
};

export default Navbar;
